export const API_ACCOUNT_MANAGERS_ROUTES = Object.freeze({
  ACCOUNT_MANAGER: 'account-managers',
  ACCOUNT_MANAGER_OPTIONS: 'account-managers/options',
});
